import React from "react";
import Select from "react-select";
import PerformerDropdownIndicator from "./PerformerDropdownIndicator";
import { ESTABLISHMENT_TYPE } from "../../../../utils/constants";

const ESTABLISHMENT_TYPE_OPTIONS = Object.values(ESTABLISHMENT_TYPE).map((each) => ({
  value: each,
  label: each,
}));

interface PerformerBaseFiltersProps {
  establishmentType: string;
  company: string;
  associateCompany: string;
  companies: any[];
  associateCompanies: any[];
  onEstablishmentTypeChange: (option: any) => void;
  onCompanyChange: (option: any) => void;
  onAssociateCompanyChange: (option: any) => void;
}

function PerformerBaseFilters({
  establishmentType,
  company,
  associateCompany,
  companies,
  associateCompanies,
  onEstablishmentTypeChange,
  onCompanyChange,
  onAssociateCompanyChange,
}: PerformerBaseFiltersProps) {
  // Sorted alphabetically by name — the auto-select logic in FieldMapping.tsx
  // already picks "first alphabetically", so the list itself needs to agree
  // on what "first" means.
  const companyOptions = [...companies]
    .sort((a: any, b: any) => (a.name || "").localeCompare(b.name || ""))
    .map((c: any) => ({ value: c.id, label: c.name }));
  // "All" (id 'all', prepended by the caller) is pinned first, not subject to
  // the alphabetical sort — everything else sorts alphabetically after it.
  const allACOption = associateCompanies.find((c: any) => c.id === "all");
  const associateCompanyOptions: any[] = [...associateCompanies]
    .filter((c: any) => c.id !== "all")
    .sort((a: any, b: any) => (a.name || "").localeCompare(b.name || ""))
    .map((c: any) => ({ value: c.id, label: c.name, logo: c.logo, favicon: c.favicon, whitelabeling_enabled: c.whitelabeling_enabled }));
  if (allACOption) {
    associateCompanyOptions.unshift({ value: "all", label: allACOption.name || "All" });
  }

  const selectedEstablishmentType = establishmentType
    ? { value: establishmentType, label: establishmentType }
    : null;

  const selectedCompany = company
    ? { value: company, label: (companies.find((c: any) => c.id === company) || {}).name || "" }
    : null;

  const selectedAssociateCompany = associateCompany
    ? { value: associateCompany, label: (associateCompanies.find((c: any) => c.id === associateCompany) || {}).name || "" }
    : null;

  return (
    <>
      <div>
        <label className="filter-label"><small>Establishment Type</small></label>
        <Select
          placeholder="Select Establishment Type"
          options={ESTABLISHMENT_TYPE_OPTIONS}
          value={selectedEstablishmentType}
          onChange={onEstablishmentTypeChange}
          className="select-control"
          components={{ DropdownIndicator: PerformerDropdownIndicator }}
          isSearchable={false}
        />
      </div>

      <div>
        <label className="filter-label"><small>Company</small></label>
        <Select
          placeholder="Select Company"
          options={companyOptions}
          value={selectedCompany}
          onChange={onCompanyChange}
          isDisabled={!establishmentType}
          className="select-control"
          components={{ DropdownIndicator: PerformerDropdownIndicator }}
        />
      </div>

      <div>
        <label className="filter-label"><small>Associate Company</small></label>
        <Select
          placeholder="Select Associate Company"
          options={associateCompanyOptions}
          value={selectedAssociateCompany}
          onChange={onAssociateCompanyChange}
          isDisabled={!company}
          className="select-control"
          components={{ DropdownIndicator: PerformerDropdownIndicator }}
        />
      </div>
    </>
  );
}

export default PerformerBaseFilters;
